import { FC } from 'react';
import './animalCardSkeleton.scss';

const AnimalCardSkeleton: FC = (): JSX.Element => {
  return (
    <div className="animal-card-skeleton">
      <div className="skeleton-image"></div>
      <div className="skeleton-content">
        <div className="skeleton-title"></div>
        <div className="skeleton-text"></div>
        <div className="skeleton-text short"></div>
        <div className="skeleton-button"></div>
      </div>
    </div>
  );
};

export default AnimalCardSkeleton;
